// extracted by mini-css-extract-plugin
export default {"error":"Select_error__CEvy1","wrapper":"Select_wrapper__WWU+C","input":"Select_input__AMJ1o","white":"Select_white__tMcwG","err":"Select_err__EawKi"};